import styled from 'styled-components';
import { Typography } from '@/components';
import { TextStyles } from '@/constants';

export const DividedLine = styled.div({
  position: 'relative',
  width: '100%',
  height: 1,
  backgroundColor: '#d0d0d0',
});

export const DividedText = styled(Typography).attrs({
  variant: TextStyles['Overline'],
})(({ theme }) => ({
  position: 'absolute',
  padding: `0 ${theme.spacing[8]}`,
  width: 'fit-content',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.colors.highEmphasisWhite,
  fontWeight: theme.fontWeight.semiBold,
}));

export const DividerWrapper = styled.div<{ isDesktop: boolean }>(({ theme, isDesktop }) => ({
  margin: `${theme.spacing[isDesktop ? 16 : 24]} 0`,
  height: 18,
  display: 'flex',
  alignItems: 'center',
}));
